// @flow

import * as React from 'react';

import { useDispatch } from 'react-redux';

import { useTranslator } from '@gandi/translate';
import { DialogContent, Base, Button, DialogFooter } from '@gandi/ui';

import { setModalState } from './module';
import getTranslation from './translations';

type Props = {
  handleCancel: (evt: SyntheticMouseEvent<>) => void,
  handleConfirmation: (evt: SyntheticMouseEvent<>) => Promise<void>,
  setConfirmationStep: (value: boolean) => void,
  /*
   * name of the phase
   */
  phase: string,
};

export function ConfirmationStep({
  handleCancel,
  handleConfirmation,
  setConfirmationStep,
  phase,
}: Props): React.MixedElement {
  const { __ } = useTranslator();
  const dispatch = useDispatch();

  return (
    <>
      <DialogContent>
        <Base
          tagName="p"
          margin="none"
          marginBottom="xsmall"
          dangerouslySetInnerHTML={__(
            'You chose to pre-register your domain in **%(phase)s**.',
            {
              phase: getTranslation(__, phase),
              withMarkdown: true,
            },
          )}
        />
        <Base margin="none" marginBottom="xsmall" tagName="p">
          {__(
            'If someone buys or pre registers the same domain name ' +
              'in an earlier phase, you will not get it.',
          )}{' '}
          <Button
            type="button"
            kind="link"
            onClick={(evt: SyntheticMouseEvent<>) => {
              evt.preventDefault();
              // $FlowFixMe[not-an-array]
              dispatch(setModalState({ phase: undefined }));
              setConfirmationStep(false);
            }}
          >
            {__('Change phase.')}
          </Button>
        </Base>
        <Base margin="none" marginBottom="xsmall" tagName="p">
          {__('You will be refunded if you do not get the domain.')}
        </Base>
        <Base margin="none" marginBottom="xsmall" tagName="p">
          {__(
            'You will follow your domain in the domain section ' +
              'as in progress, until the general availability opening, waiting ' +
              'to get the validation of the registry',
          )}
        </Base>
      </DialogContent>
      <DialogFooter>
        <Button type="button" kind="outline" onClick={handleCancel}>
          {__('Cancel')}
        </Button>
        <Button type="button" onClick={handleConfirmation}>
          {__('Confirm')}
        </Button>
      </DialogFooter>
    </>
  );
}
